import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportDataService {

  private baseUrl = `${environment.apiUrl}/api/export-data`;

  constructor(private http: HttpClient) {}

  getTransacciones(usuarioPk: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/transactions/${usuarioPk}`);
  }

  exportar(data: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/export`, data);
  }
}